<template>
  <div class="footer-page">
    <div class="header">
      <div class="otherWebsites">
        <span>友情链接：中国政府网</span>
        <span>国家体育总局官网</span>
        <span>中华全国体育总会</span>
        <span>中国奥委会</span>
        <span>中国武术协会</span>
      </div>
    </div>
    <div class="info">
      <div class="cell">
        <p class="title">网站信息</p>
        <p class="content">通过平台实现参赛方线上快速报名、优化赛事举办流程、将赛事信息数据化、可视化</p>
      </div>
      <div class="cell">
        <p class="title">联系我们</p>
        <p class="content">联系电话：023-68631081</p>
        <p class="content" style="margin-top: 10px;">技术支持：<a href="/">道吧网</a></p>
      </div>
      <div class="platform">
        <p>
          <!-- <img v-if="programId === 12" style="height:40px;" src="../../../assets/weapon/weapon.png"/> -->
          <img style="width:55px;" :src="'https://static.daoba.com/sportsLogo/'+ programId +'.png'" alt="">
          <!-- <img src="../../../assets/weapon/weapon.png"/> -->
        </p>
        <!-- <p class="name">武术兵道</p> -->
        <p class="enName">Smart Sports Platform</p>
      </div>
    </div>
    <div class="footer-end">
      <div>
        <span>建议使用1280x800分辨率 谷歌浏览器</span>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.footer-page {
  color: #fff;
  /*padding: 30px 10px;*/
  padding-top: 20px;
  background-image: url('../../../assets/weapon/weaponFooter.png');
  .header {
    position: relative;
    .otherWebsites {
      display: flex;
      justify-content: space-around;
      border-bottom: 1px solid #ddd;
      width: 1200px;
      margin: 0 auto;
      margin-bottom: 30px;

      span {
        padding: 0px 20px 20px 20px;
        cursor: pointer;
      }
    }
  }

  .info {
    display: flex;
    justify-content: space-between;
    width: 1200px;
    margin: 0 auto;
    align-items: flex-start;
    .cell {
      width: 33.33%;
      .title {
        font-size: 16px;
        margin-bottom: 14px;
      }
      .content {
        font-size: 12px;
      }
    }
    .platform {
      text-align: center;
      margin-bottom: 14px;
      .name {
        font-size: 16px;
        margin-top: 14px;
      }
      .enName {
        font-size: 12px;
      }
      p img {
        height: 48px;
      }
    }

    .contact {
      display: flex;
      padding: 20px 0;
      span {
        height: 16px;
        line-height: 16px;
        display: block;
        &:first-child {
          padding-right: 20px;
          border-right: 1px solid #fff;
        }
        &:last-child {
          padding-left: 20px;
        }
      }
    }
  }
  .footer-end {
    width: 1200px;
    margin: 0 auto;
    padding-top: 12px;
    text-align: center;
    border-top: 2px solid hsla(0,0%,100%,.2);
    font-size: 12px;
    .footerCell {
      color: #fff;
      margin-right: 10px;
      margin-bottom: 4px;
      display: inline-block;
    }
  }

  a {
    color: #fff;
  }
  .describe {
    line-height: 30px;
    a {
      margin-right: 30px;
    }
  }
}
</style>

<script>
export default {
  name: 'Home',
  mounted () {
    // 初始化
  },
  data () {
    return {
      title: '底部',
      programId: this.$route.query.programId
    }
  },
  methods: {
    onSubmit () {}
  }
}
</script>



// WEBPACK FOOTER //
// src/daoba-match/views/program/components/Footer.vue